var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "sort",
  "use": "sort-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sort\"><path d=\"M6 36h12v-4h-12v4zm0-24v4h36v-4h-36zm0 14h24v-4h-24v4z\" /><path d=\"M0 0h48v48h-48z\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id